module.exports = __webpack_public_path__ + "media/images/homes/customer_receipt2x-99c42405a433481b527a7c38d47ffa6a.png";